import { getActivityConfig } from "@/lib/activities/registry";
import type { ShareableEntity } from "@/lib/api/shareable-entities";
import type { HubView } from "./use-hub-store";

/** Canonical Hub viewer for a shareable entity (list / history / chat open). */
export function hubViewForEntity(entity: ShareableEntity): HubView {
  if (entity.entityType === "activity") {
    const activityType = entity.activity?.activityType;
    const module = activityType ? getActivityConfig(activityType) : undefined;
    if (module) return module.hubView;
  }

  switch (entity.entityType) {
    case "moment":
      return "view-moment";
    case "swap":
      return "view-swap";
    case "note":
    case "activity":
      return "view-note";
    default: {
      const _exhaustive: never = entity.entityType;
      return _exhaustive;
    }
  }
}

export function hubViewForActivityType(activityType: string): HubView | null {
  return getActivityConfig(activityType)?.hubView ?? null;
}

export function hubViewForContentEntityType(
  entityType: "note" | "moment" | "swap",
): HubView {
  switch (entityType) {
    case "note":
      return "view-note";
    case "moment":
      return "view-moment";
    case "swap":
      return "view-swap";
    default: {
      const _exhaustive: never = entityType;
      return _exhaustive;
    }
  }
}
